module.exports = require("@aws-sdk/client-ses");